<template>
    <div >
        <van-sticky class="main-tabs" :z-index="100">
            <van-tabs v-model="activeName" @change="changeTab">
                <van-tab title="待领取" name="1">
                    <van-search v-model="keyword" placeholder="请输入拣货单号" />
                </van-tab>
                <van-tab title="已开始" name="4">
                    <van-search v-model="keyword" placeholder="请输入拣货单号" />
                </van-tab>
                <van-tab title="已完成" name="2">
                </van-tab>
            </van-tabs>
        </van-sticky>
        <component 
            :key="activeName"
            :is="dynamicComponent"
            :active-name="activeName"
            :keyword="keyword"
        />
    </div>
</template>

<script>
import { Search, List,CellGroup, Cell,Row,Col,Icon,Tag,Tabs,Tab,Sticky,Empty,Notify, Button } from 'vant';
import mixin_ossign from '../../../common/mixin_ossign';
import Complete from './components/complete.vue';
import Start from './components/start.vue';
import monitor from './mixins/monitor';
import BeforeClaim from './components/beforeClaim.vue';


export default {
    mixins: [monitor,mixin_ossign],
    components: {
        [Search.name]: Search,
        [List.name]: List,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Row.name]: Row,
        [Col.name]: Col,
        [Icon.name]: Icon,
        [Tag.name]: Tag,
        [Tabs.name]: Tabs,
        [Tab.name]: Tab,
        [Sticky.name]: Sticky,
        [Empty.name]: Empty,
        [Notify.name]: Notify,
        Complete,
        Start,
        [Button.name]: Button,
        BeforeClaim
    },
    data() {
        return {
            online: true,
            activeName: '1',
            keyword: '',
            list: [],
            storedData: [],
            isApp: '',//区分是消息推送点入还是app打开
        };
    },
    created() {
        this.isApp = navigator.userAgent.indexOf('demeter/') != -1?'app':'';//是否在app中
        this.activeName = String(this.$route.query.activeName || '1');
    },
    mounted() {
        this.$jsbridge.call('setTitle', { title: '拣货工单' }, null);
    },
    computed: {
        data() {
            if (!this.keyword) {
                return this.list;
            }
            return this.list.filter((item) => {
                return item.pickNumber.includes(this.keyword);
            });
        },
        dynamicComponent() {
            return this.getComponent(this.activeName);
        }
    },
    beforeRouteLeave(to, from, next) {
        from.meta.keepAlive = false;
        next();
    },
    methods: {
        getComponent(activeName) {
            switch (activeName) {
                case '1': return 'BeforeClaim';
                case '2': return 'Complete';
                case '4': return 'Start';
                default: return 'BeforeClaim';
            }
        },
        changeTab(name) {
            this.activeName = name;
            this.keyword = '';
            this.$router.replace({
                query: { 
                    ...this.$route.query,
                    activeName: name 
                }
            });
        },
    },
    watch: {
        '$route.query.activeName': {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.activeName = newVal;
                }
            }
        }
    }
};
</script>

<style scoped>
.card-cell {
    margin:5px 10px;
    padding: 5px;
    border:1px solid #efefef;
    border-radius: 8px;
    background-color: #fff;
    margin-bottom: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    padding-bottom: 40px;
}
.card-cell .arrow-icon {
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);
    font-size: 24px;
    color: #ccc;
    z-index: 1;
}
.card-cell .inner-cell{
    padding:2px 0px;
}
.card-cell .inner-cell .van-cell__title{
    width:70px;
    flex: none;
    text-align: right;
}
.card-cell .inner-cell .van-cell__value{
    text-align: left;
    color:#787878
}

.claim-button {
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 2;
}
</style>